import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import DocumentsNodeName from 'src/common/DocumentsLibrary/DocumentsView/DocsName';
import { IFileNode } from 'src/models/documentsLibrary/types';
import classNames from 'classnames';
import SingleLineSkeleton from 'src/common/betaComponents/SingleLineSkeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

interface ITextResponseAttachmentProps {
  file: IFileNode;
  onDeleteFile: (fileId: string) => void;
  isLoading?: boolean;
  readOnly?: boolean;
  procurementId?: string;
}

export const TextResponseAttachment: FC<ITextResponseAttachmentProps> = props => {
  const { file, onDeleteFile, isLoading, readOnly, procurementId } = props;

  const onDeleteAttachedFile = useCallback(() => {
    onDeleteFile(file.id);
  }, [file.id, onDeleteFile]);

  return (
    <li className={styles.file}>
      {isLoading && <SingleLineSkeleton active loading />}
      <div className={styles.fileName}>
        <DocumentsNodeName docsNode={file} eventSource="Answer - Task Page" procurementId={procurementId} />
      </div>
      {!readOnly && (
        <button className={classNames(styles.unAttachButton, styles.button)} onClick={onDeleteAttachedFile}>
          <FontAwesomeIcon icon={faTimes} className={styles.unAttachIcon} />
        </button>
      )}
    </li>
  );
};

export default TextResponseAttachment;
